export default "__VITE_ASSET__BbKBQdDI__"